export const MAIN = '/';

export const HOME = '/profile/:name';
export const HOME_PATH = '/profile/';

export const GITHUB = '/github/:username';
export const GITHUB_PATH = '/github/';

export const REPO = '/repo/:username/:repo';
export const REPO_PATH = '/repo/';